export class Position {
    constructor(init) {
        this.symbol = "";
        this.quantity = 0;
        this.price = 1;
        this.weight = 1;
        this.deltaQuantity = 0;
        Object.assign(this, init);
    }
    getValue(includeDelta = false) {
        const quantity = includeDelta ? this.quantity + this.deltaQuantity : this.quantity;
        return quantity * this.price;
    }
}
